export enum WarrantyStatus {
    NEW = 1,
    ACCEPTED = 2,
    RE_OPEN = 3,
}
